import * as React from 'react';
import ChangelogModal, {ChangelogModalContent, ChangelogModalHeader} from "./ChangelogModal";
import reactElementToJSXString from 'react-element-to-jsx-string';
import ReactMarkdown from 'react-markdown';

import changelog from '../changelog.md';
import server from '../../../../integration/server/server-services';

function headingRenderer(props: any) {
    const text: string = reactElementToJSXString(props.children[0]);

    let slug = "";
    const headerFormat = /[0-9]{4}-[0-9]+[.][0-9]+[.][0-9]+/
    if (text.match(headerFormat)) {
        slug = text.match(headerFormat)[0].replace(/\W/g, '-');
        const anchor = React.createElement('a', {id: slug, className: "changelog-anchor"}, props.children);
        const title = React.createElement('h' + props.level, {id: slug}, props.children);
        return React.createElement('div', {}, anchor, title);
    }
    const title = React.createElement('h' + props.level, {id: slug, className: "changelog-header"}, props.children);
    return React.createElement('div', {}, title);
}

interface ChangelogProps {
    server: server,
}

interface ChangelogState {
    loading: boolean;
    deployTimestamp?: Date;
    version?: string;
}

class Changelog extends React.Component<ChangelogProps, ChangelogState> {

    constructor(props: Readonly<ChangelogProps>) {
        super(props);
        this.state = {loading: true};
    }

    componentDidMount() {
        this.props.server.getVersionInfo().then(versions => {
            this.setState({loading: false, deployTimestamp: new Date(versions.deploytime),  version: versions.version});
        })
    }

    getMonth(monthNumber: number | string) {
        switch(monthNumber) {
            case 0:
                return "Januar";
            case 1:
                return "Februar";
            case 2:
                return "Mars";
            case 3:
                return "April";
            case 4:
                return "Mai";
            case 5:
                return "Juni";
            case 6:
                return "Juli";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "Oktober";
            case 10:
                return "November";
            case 11:
                return "Desember";
            default:
                return monthNumber;
        }
    }

    render() {
        let content;
        if (this.state.loading) {
            content = <div className={"cssloader"} />;
        } else {

            let month = this.getMonth(this.state.deployTimestamp.getMonth());
            let day = this.state.deployTimestamp.toLocaleDateString("da-DK", {day: "numeric"}); // da-DK da det er bug for nb-NO atm

            // Replace first period in version with a dash to match hand written format
            const version = this.state.version.replace(".", "-");

            let template: string = changelog;
            template = template.replace("${releaseYear}", this.state.deployTimestamp.getFullYear().toString());
            template = template.replace("${releaseMonth}", month.toString());
            template = template.replace("${releaseDate}", day + " " + month.toString().toLocaleLowerCase());
            template = template.replace("${releaseVersion}", version);

            content = <ReactMarkdown
                source={template}
                renderers={{heading: headingRenderer}}
            />
        }


        return (
            <>
                <ChangelogModal>
                    <ChangelogModalHeader title={"Endringslogg"}/>
                    <a className={"df-backlink changelog-back"} href={"/"}>
                        <i className={"fa fa-arrow-left"}/>
                        <span>Tilbake</span>
                    </a>
                    <ChangelogModalContent>
                        {content}
                    </ChangelogModalContent>
                </ChangelogModal>
            </>
        );
    }
}

export default Changelog;
